module.exports = __webpack_public_path__ + "static/hydra-e6867b792714b05741590c779bbaf9ed.jpg";